/* ROI funnel tracking. This intentionally sends only product and interaction
 * metadata—never the shopper's calculator assumptions or contact details. */
(() => {
  if (window.AlamoRoiTracking) return;

  const VERSION = 1;
  const allowedKeys = new Set([
    'roi_model',
    'roi_service',
    'product_id',
    'product_handle',
    'variant_id',
    'listed_price',
    'product_available',
    'surface',
  ]);

  const cleanText = (value, maxLength = 140) => String(value || '')
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_\-./]/g, '')
    .slice(0, maxLength);

  const cleanPayload = (payload = {}) => {
    const result = { roi_tracking_version: VERSION };
    Object.entries(payload).forEach(([key, value]) => {
      if (!allowedKeys.has(key) || value === undefined || value === null || value === '') return;
      if (key === 'listed_price') {
        const price = Number(value);
        if (Number.isFinite(price) && price >= 0) result[key] = Math.round(price * 100) / 100;
        return;
      }
      if (key === 'product_available') {
        result[key] = Boolean(value);
        return;
      }
      const text = cleanText(value);
      if (text) result[key] = text;
    });
    return result;
  };

  const privacyAllows = (method) => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return typeof privacy?.[method] !== 'function' || privacy[method]();
    } catch (_error) {
      return false;
    }
  };

  const track = (eventName, payload = {}) => {
    const name = cleanText(eventName, 64);
    if (!name) return;
    const data = cleanPayload(payload);

    if (privacyAllows('analyticsProcessingAllowed')) {
      try { window.Shopify?.analytics?.publish?.(name, data); } catch (_error) {}
      try { window.gtag?.('event', name, data); } catch (_error) {}
    }

    if (privacyAllows('marketingAllowed')) {
      try { window.fbq?.('trackCustom', name, data); } catch (_error) {}
    }

    try {
      window.dispatchEvent(new CustomEvent(name, { detail: data }));
    } catch (_error) {}
  };

  const trackOnce = (eventName, payload = {}, scope = '') => {
    const key = `alamo-roi:${cleanText(eventName, 64)}:${cleanText(scope, 180)}`;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, '1');
    } catch (_error) {}
    track(eventName, payload);
  };

  window.AlamoRoiTracking = { track, trackOnce };
})();
